import api from './data.services'

const nationalitiesSrv = 'locations/nationalities'
const forecastsSrv = 'forecasts'
const gendersSrv = 'genders'
const regionsSrv = 'locations/regions'
const citiesSrv = 'locations/cities'
const communesSrv = 'locations/communes'

const getNationalities = async () => {
  try {
    const resp: any = await api.get(nationalitiesSrv)

    return {
      status: 'Ok',
      data: (resp && resp.data && resp.data.nationalities ? resp.data.nationalities : [])
    }
  } catch (error) {
    return {
      status: 'Error',
      data: [],
      message: 'Error server al obtener nacionalidades!'
    }
  }
}

const getForecasts = async () => {
  try {
    const resp: any = await api.get(forecastsSrv)

    return {
      status: 'Ok',
      data: (resp && resp.data && resp.data.forecasts ? resp.data.forecasts : [])
    }
  } catch (error) {
    return {
      status: 'Error',
      data: [],
      message: 'Error server al obtener previsiones!'
    }
  }
}

const getGenders = async () => {
  try {
    const resp: any = await api.get(gendersSrv)

    return {
      status: 'Ok',
      data: (resp && resp.data && resp.data.genders ? resp.data.genders : [])
    }
  } catch (error) {
    return {
      status: 'Error',
      data: [],
      message: 'Error server al obtener generos!'
    }
  }
}

const getRegions = async () => {
  try {
    const resp: any = await api.getSrv(regionsSrv)

    return {
      status: 'Ok',
      data: (resp && resp.data && resp.data.regions ? resp.data.regions : [])
    }
  } catch (error) {
    return {
      status: 'Error',
      data: [],
      message: 'Error server al obtener regiones!'
    }
  }
}

const getCities = async (regionId: number) => {
  try {
    const resp: any = await api.getSrv(`${citiesSrv}/${regionId}`)

    return {
      status: 'Ok',
      data: (resp && resp.data && resp.data.cities ? resp.data.cities : [])
    }
  } catch (error) {
    return {
      status: 'Error',
      data: [],
      message: 'Error server al obtener provincias!'
    }
  }
}

const getCommunes = async (cityId: number) => {
  try {
    const resp: any = await api.getSrv(`${communesSrv}/${cityId}`)

    return {
      status: 'Ok',
      data: (resp && resp.data && resp.data.communes ? resp.data.communes : [])
    }
  } catch (error) {
    return {
      status: 'Error',
      data: [],
      message: 'Error server al obtener comunas!'
    }
  }
}

export const commonService = {
  getNationalities,
  getForecasts,
  getGenders,
  getRegions,
  getCities,
  getCommunes
}